import React from "react";

import Section from "./Section";

function NavBar(props) {
  return (
    <nav className="nav flex-column">
      <div className="scroll">
        <div className="accordion" id="accordionExample">
          {props.sections.map(section => {
            return (
              <Section
                handleVideoSelect={props.handleVideoSelect}
                current={props.current}
                show={section.id === props.idCurrentSection ? true : false}
                key={section.id}
                sectionId={section.id}
                section={section}
                sections={props.sections}
              />
            );
          })}
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
